import React, { useEffect } from "react";
import styled from "styled-components";
import { AltInfo } from '../../icons';
import PrimaryButton from '../PrimaryButton';

interface AlertModalProps {
  setError?: (value: boolean) => void;
  errorMessage: string;
  errorHeader?: string;
  showError: boolean;
  fromQuotes?: boolean;
  withdrawQuote?: Function;
  handleAlertClose?: Function;
  loader?: boolean;
  setLoader?: Function;
}

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const ModalContent = styled.div`
  background: #ffffff;
  border-radius: 4px;
  width: 90%;
  max-width: 700px;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.2);
  text-align: center;
  position: relative;
  transform: scale(0.8);
  animation: popIn 0.3s ease-out forwards;

  @keyframes popIn {
    from {
      transform: scale(0.8);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

const ModalHeader = styled.div`
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  margin-top: 15px;
`;

const ModalBody = styled.div`
  padding: 33px 33px 33px;
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.span`
  display: flex;
  text-align: center;
`;

const Message = styled.div`
  margin-left: 10px;
  text-align: justify;
`;

const Text = styled.p`
  margin: 0px;
`;

const ModalFooter = styled.div`
  min-height: 56px;
  text-align: right;
  background-color: #ebebeb;
  border-top: 1px solid #ddd;
  padding: 0 33px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  text-align: center;
  padding: 4px 10px 4px 10px;
  text-transform: uppercase;
  height: 31px;
  margin: 10px;
  span {
    font-size: 14px;
    font-weight: bold;
  }
`;

export const StyledPrimaryButtonWith = styled(PrimaryButton)`
  text-align: center;
  padding: 4px 10px 4px 10px;
  text-transform: uppercase;
  height: 31px;
  margin: 10px;
  background-color: #0173C6;
  span {
    font-size: 14px;
    font-weight: bold;
  }
`;

export const StyledPrimaryButtonOutline = styled(PrimaryButton)`
text-align: center;
padding: 4px 10px 4px 10px;
text-transform: uppercase;
height: 31px;
margin: 10px;
border: 1px solid #0173C6;
background-color: #fff;
color: #0173C6!important;

&:hover {
  background-color: #0173C6;
  color: #fff!important;
}
span {
  font-size: 14px;
  font-weight: bold;
}
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  text-transform: uppercase;
`;

const AlertModal: React.FC<AlertModalProps> = ({ setError, showError, errorMessage, errorHeader, fromQuotes = false, withdrawQuote, handleAlertClose, loader = false, setLoader }) => {
  const [show, setShow] = React.useState(false);

  useEffect(() => {
    if (showError) {
      setShow(showError);
    }
    if (setLoader) {
      setShow(!show);
    }
  }, []);



  const HandlerClose = () => {
    setShow(!show);
    if (setError) {
      setError(false);
    }
    if (fromQuotes && handleAlertClose) {
      handleAlertClose();
    }
  };

  return (
    <>
      {show && (
        <ModalOverlay>
          <ModalContent>
            <ModalHeader>{errorHeader ? errorHeader : <>&nbsp;</>}</ModalHeader>
            <ModalBody>
              <IconWrapper>
                <AltInfo />
              </IconWrapper>
              <Message>
                <Text>{errorMessage}</Text>
              </Message>
            </ModalBody>
            <ModalFooter>
              {fromQuotes ? (
                <>
                  {!loader ? (
                    <StyledPrimaryButtonOutline
                      onClick={HandlerClose}
                    >
                      Cancel
                    </StyledPrimaryButtonOutline>
                  ) : (
                    <StyledPrimaryButtonOutline
                      disabled
                      onClick={HandlerClose}
                    >
                      Cancel
                    </StyledPrimaryButtonOutline>
                  )}
                  {!loader ? (
                    <StyledPrimaryButtonWith
                      onClick={withdrawQuote}
                    >
                      Withdraw
                    </StyledPrimaryButtonWith>
                  ) : (
                    <StyledPrimaryButtonWith>
                      Processing
                    </StyledPrimaryButtonWith>
                  )}
                </>
              ) : (
                <StyledPrimaryButton
                  onClick={HandlerClose}
                >
                  OK
                </StyledPrimaryButton>
              )}
            </ModalFooter>
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
};

export default AlertModal;
